/* @flow */
import { action, observable, runInAction } from 'mobx';

import { ApiModel } from 'api/ApiModel';
import type ApiService from 'services/ApiService';

/**
 * Store to handle user's data regarding CaaS
 */
export default class UserCaaSStore extends ApiModel {
  @observable
  hasCaaSAssets: boolean = false;

  @action
  async checkForCaaSAssets(userId: string) {
    let hasCaaSAssets = false;
    const res: *[] | null = await this.api.getResource(`caas/user/${userId}/assets`);

    if (res === null) {
      console.warn("Failed to check for user's CaaS assets.");
    } else {
      hasCaaSAssets = res.length > 0;
    }

    runInAction(() => (this.hasCaaSAssets = hasCaaSAssets));
  }
}
